import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { useLogin } from '../hooks'

import { BASE_URL } from '../../constants'

import styles from './Login.module.css'

const Login = (props) => {
  const [{ isLoggedIn, isLoggingIn, error }, { login, init }] = useLogin()
  const { from } = props.location.state || { from: { pathname: '/' } }

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  // Load token/user from localStorage if login not expired
  useEffect(init, [])

  if (isLoggedIn) {
    return <Redirect to={from} />
  }

  const onEnter = (e) => {
    if (e.keyCode === 13) {
      // on enter
      login(username, password)
    }
  }

  return (
    <div className={styles.container}>
      <img
        src={`${BASE_URL}images/irissSignin.png`}
        className={styles.eye}
        alt="IrissSigninLogo"
      />
      <h2 className={styles.header}>iRISS | Sign In</h2>
      <div>
        <i className={'fa fa-user ' + styles.inputIcon}></i>
        {isLoggingIn ? (
          <input
            className={styles.input}
            type="text"
            placeholder="Username"
            value={username}
            disabled="disabled"
          />
        ) : (
          <input
            className={styles.input}
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={onEnter}
          />
        )}
      </div>
      <div>
        <i className={'fa fa-key ' + styles.inputIcon}></i>
        {isLoggingIn ? (
          <input
            className={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            disabled="disabled"
          />
        ) : (
          <input
            className={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={onEnter}
          />
        )}
      </div>
      {isLoggingIn ? (
        <button className={styles.submitButton} type="submit">
          <i className="fa fa-spinner fa-spin"></i> Signing In...
        </button>
      ) : (
        <button
          className={styles.submitButton}
          type="submit"
          onClick={() => login(username, password)}
        >
          Sign in to iRISS
        </button>
      )}
      {error && <div className={styles.error}>{error}</div>}

      <p className={styles.footer}>
        Requires a 'www.horrycountysc.gov' account with special authorization.
      </p>
      <p className={styles.footer}>
        <a href="https://www.horrycountysc.gov">
          Register | Forgot Password
        </a>
      </p>
    </div>
  )
}

export default Login
